import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import './Business.css';

const ITEMS = [
  { to: `http://www.nodascreen.co.jp`, img: require('../images/Business/1.png') },
  { to: `http://www.aft-website.com`, img: require('../images/Business/2.png') },
  { to: `http://www.akelastomer.com`, img: require('../images/Business/3.png') },
  { to: `http://www.ube-ind.co.jp`, img: require('../images/Business/4.png') },
  { to: `http://www.sanyo-chemical.co.jp`, img: require('../images/Business/5.png') },
  { to: `http://www.shiraishi.co.jp`, img: require('../images/Business/6.png') },
  { to: `http://www.dnp.co.jp`, img: require('../images/Business/7.png') },
  { to: `http://www.filcon.co.jp`, img: require('../images/Business/8.png') },
  { to: null, img: require('../images/Business/9.png') },
  { to: `http://www.kobelco.co.jp`, img: require('../images/Business/10.png') },
  { to: `http://www.mec-co.com`, img: require('../images/Business/11.png') },
  { to: `http://www.nakata-eng.co.jp`, img: require('../images/Business/12.png') },
  { to: `http://www.nippon-roll.co.jp`, img: require('../images/Business/13.png') },
  { to: `http://www.sumitomoseika.co.jp`, img: require('../images/Business/14.png') },
  { to: `http://www.yamato-scale.co.jp`, img: require('../images/Business/15.png') },
  { to: `http://www.tokuyama.co.jp`, img: require('../images/Business/16.png') },
  { to: `http://www.tosoh.co.jp`, img: require('../images/Business/17.png') },
];

export default class Business extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    onClickClose: PropTypes.func,
  };

  render() {
    return (
      <div className={classnames('Business', this.props.className)}>
        <div
          className="Business__close"
          onClick={this.props.onClickClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <polygon fillRule="evenodd" points="12 10.586 7.05 5.636 5.636 7.05 10.586 12 5.636 16.95 7.05 18.364 12 13.414 16.95 18.364 18.364 16.95 13.414 12 18.364 7.05 16.95 5.636 12 10.586"/>
          </svg>
        </div>
        <h2 className="Business__title">
          <FormattedMessage id="Business.business"/>
        </h2>
        <div className="Business__items">
          {
            ITEMS.map(({ to, img }, idx) => (
              <a
                key={idx}
                className="Business__item"
                target="_blank_"
                href={to}>
                <img
                  className="Business__img"
                  src={img}
                  alt={to || 'Hansuk'}
                />
              </a>
            ))
          }
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Business.js